import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

declare var axios:any;
platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
  axios.defaults.withCredentials = true;